import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { LMSMenuItem } from 'src/app/core/models/menuitem.model';
//import { SwitchModeService } from 'src/app/core/services/switch-mode.service';
import { UserService } from 'src/app/core/services/lmsuser.service';
import { PostcodesService } from 'src/app/core/services/postcodes.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';

import { AppUtilityService } from '../app-utility.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
    // 2. Emits an event when the user clicks the hamburger menu
  @Output() toggleMobileMenu = new EventEmitter<void>();

  private static readonly globalOverridesStorageKey = 'lms.legacy.toggle.enable-global-overrides';
  private static readonly globalOverridesBodyClass = 'legacy-toggle-enable-global-overrides';


  MenuList$ = this.userService.MenusControl$;
  isVisible = true;
  showTribute = environment.showTribute
  private readonly STORAGE_KEY = 'tribute_dismissed_v10_2026'; // Update per release
  isDark = false;
  public version: string = environment.version;
  environmentName: string;
  options: FormGroup;
  menus: LMSMenuItem[] = [];

  useractioncolor = 3;
  usertoken: any;
  DisplayedUsername = '';
  userBranchName = '';
  clicked: boolean;
  useNewLandingLayout: boolean = false;
  globalOverridesEnabled = true;

  showLayoutToggle: boolean = environment.enableNewLandingLayout; // Show toggle in debug mode
  showStyleToggle: boolean = environment.enableDebug;
  private destroy$ = new Subject<void>();
  private isLoggedIn : boolean;

  constructor(
    public global_utility: AppUtilityService,
    private router: Router,
    fb: FormBuilder,
    private postcodeService: PostcodesService,
    public userService :UserService,
    private storageService: StorageService
  ) {

    this.options = fb.group({
      fixed: true,
      top: 0,
      bottom: 0,
    });
  }

  ngOnInit(): void {
    if (localStorage.getItem(this.STORAGE_KEY)) {
      this.isVisible = false;
    }

    // Initialize landing layout preference
    const savedPref = this.storageService.getLandingLayoutPreference();
    if(savedPref !== null && this.useNewLandingLayout !== savedPref) {
      this.useNewLandingLayout = savedPref !== null ? savedPref : this.useNewLandingLayout;
      this.toggleLandingLayout();
    }

    this.globalOverridesEnabled = this.getStoredGlobalOverrideState();
    this.applyGlobalOverrideClass();

    this.userService.onLogginChanged.subscribe({
      next: (isloggedin) => {
        this.isLoggedIn = isloggedin;
        if (isloggedin && this.DisplayedUsername !== this.global_utility.getGlobalData('userDisplay')) {
          this.DisplayedUsername = this.global_utility.getGlobalData('userDisplay') ??'';
          this.userBranchName = this.global_utility.getGlobalData('branch_Name') ?? '';
        }

        if (!isloggedin) {
          this.global_utility.stopLoading();
        }
      },
      complete: () => {
        this.global_utility.stopLoading();
      },
      error: () => {
        this.global_utility.stopLoading();
      },
    });

    this.environmentName = environment.name;
    //If User is not logged in then do Login
    //********  OR
    //Current User and user in Session is different - UnAUth
    // this.userService.ValidUserLoaded$.pipe(tap((val)=> {
    //   console.log('NavBar VAlidUser >>', val);
    // }));
    //this.userService.getLMSUserProfile();
    //this.userService.onLMSUserProfile();
  }

  dismiss() {
    this.isVisible = false;
    localStorage.setItem(this.STORAGE_KEY, 'true');
  }

  navigate(route: string) {
    console.log(route);
    this.router.navigate([route]).catch((reas) => {
      console.error(reas);
    });
  }

    // 4. Method triggered by the mobile hamburger button
  onMenuClick(): void {
    this.toggleMobileMenu.emit();
  }

  setClicked(val: boolean): void {
    this.clicked = val;
  }
  changeMode() {
    this.isDark = !this.isDark;

    //this.switchMode.handleSwitchMode(this.isDark);
  }

  toggleLandingLayout() {
    // Don't toggle here - ngModel already handles it
    // Just save the preference and reload if on landing page
    this.storageService.setLandingLayoutPreference(this.useNewLandingLayout);

    // Reload the page to apply the new layout if user is on landing page
    if (this.router.url.includes('branchmanager') ||
        this.router.url.includes('areamanager') ||
        this.router.url.includes('agent') ||
        this.router.url.includes('regionalmanager')) {
      window.location.reload();
    }
  }

  onGlobalOverridesChange(enabled: boolean): void {
    this.globalOverridesEnabled = enabled;
    localStorage.setItem(NavbarComponent.globalOverridesStorageKey, String(enabled));
    this.applyGlobalOverrideClass();
  }

  private getStoredGlobalOverrideState(): boolean {
    const storedValue = localStorage.getItem(NavbarComponent.globalOverridesStorageKey);
    return storedValue !== 'false';
  }

  private applyGlobalOverrideClass(): void {
    if (this.globalOverridesEnabled) {
      document.body.classList.add(NavbarComponent.globalOverridesBodyClass);
      return;
    }

    document.body.classList.remove(NavbarComponent.globalOverridesBodyClass);
  }

  logout() {
      this.userService.logOutUser();
  }

  get userDisplay() {
    this.DisplayedUsername = this.global_utility.getGlobalData("userDisplay");
    //this.userService.getLMSUserProfile().pipe
    return this.DisplayedUsername;
    //return `${this.userService.userDisplayName || this.DisplayedUsername}`;
  }

  hasSubmenu(item: any) {
    return item.submenus && item.submenus.length > 0;
  }

  closeCollapsedMenu(collapseRef: { collapsed?: boolean; hide?: () => void }): void {
    if (window.innerWidth >= 992) {
      return;
    }

    if (collapseRef?.collapsed === false && typeof collapseRef.hide === 'function') {
      collapseRef.hide();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
